import React from 'react';
import {
    Modal,
    Button,
    Row,
    Col,
    Form
} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const MediaForm = ({
    showModal,
    handleCloseModal,
    handleSubmit,
    handleFileChange,
    handleVideoUrlChange,
    renderInputFields,
    availableLanguages,
    selectedAction
}) => {

    const { t } = useTranslation();

    // ✅ SAFE fallback
    const safeLanguages =
        availableLanguages || [];

    return (
        <Modal
            show={showModal}
            onHide={handleCloseModal}
            size="xl"
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    Ajouter un média
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>

                <Form onSubmit={handleSubmit}>

                    {selectedAction === 'photo' && (
                        <Form.Group>
                            <Form.Label>
                                Photo (JPG uniquement)
                            </Form.Label>

                            <Form.Control
                                id="file"
                                type="file"
                                name="file"
                                onChange={handleFileChange}
                                accept=".jpg"
                            />
                        </Form.Group>
                    )}

                    {selectedAction === 'video' && (
                        <Form.Group>
                            <Form.Label>
                                URL de la vidéo YouTube
                                (https://www.youtube.com/watch?v=...)
                            </Form.Label>

                            <Form.Control
                                id="videoUrl"
                                type="text"
                                name="videoUrl"
                                onChange={handleVideoUrlChange}
                            />
                        </Form.Group>
                    )}

                    <Row className="margin-top-20">

                        {safeLanguages.map(
                            (language, index) => (
                                <Col key={language || index}>
                                    {renderInputFields(
                                        language
                                    )}
                                </Col>
                            )
                        )}

                    </Row>

                </Form>

            </Modal.Body>

            <Modal.Footer className="justify-content-center">
                <Button
                    variant="secondary"
                    onClick={handleCloseModal}
                >
                    {t('CANCEL')}
                </Button>

                <Button
                    variant="primary"
                    onClick={handleSubmit}
                >
                    {t('ADD')}
                </Button>
            </Modal.Footer>

        </Modal>
    );
};

export default MediaForm;